var React = require('react');

function UserIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12,12.73 C16.46,12.73 20,16.36 20,18.64 C20,20.8208696 16.7153875,20.9888847 12.5703394,20.9993721 L11.4296606,20.9994263 C7.28461248,20.9897164 4,20.8304348 4,18.64 C4,16.35 7.56,12.73 12,12.73 Z M12.03,3 C14.1783877,3 15.92,4.74161232 15.92,6.89 C15.92,9.03838768 14.1783877,10.78 12.03,10.78 C9.88161232,10.78 8.14,9.03838768 8.14,6.89 C8.14,4.74161232 9.88161232,3 12.03,3 Z"}));
}

UserIcon.defaultProps = {"data-dmid":"dm-user","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = UserIcon;

UserIcon.default = UserIcon;
